<template>
  <!-- fremcast video ID cQK53HaXmrg -->
  <youtube
    :video-id="id"
    :player-vars="playerVars"
    fit-parent
    ref="youtube"
    @playing="playing"
    @ended="ended"
  />
</template>
<script>
export default {
  data() {
    return {
      play: false,
      playerVars: {
        autoplay: 1,
        controls: 0,
        rel: 0,
        showinfo: 0,
        mute: 1,
        origin: 'https://fremcast.com.host'
      },
    };
  },
  props: {
    id: {
      type: String,
      default: 'cQK53HaXmrg'
    }
  },
  methods: {
    //@todo: Move this method to youtube video field
    playing() {
      this.play = true
      this.playCtrl = true
    },
    //@todo: Move this method to youtube video field
    ended() {
      this.player.playVideo()
    },
  }
}
</script>